
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFBE1B","d":"M100 0c55.23 0 100 44.77 100 100s-44.77 100-100 100S0 155.23 0 100 44.77 0 100 0z"}}),_c('path',{attrs:{"fill":"#707070","d":"M66.296 87.601h69.47v46h-69.47z"}}),_c('path',{attrs:{"fill":"#707070","d":"M143.1 89.84H58.96l42.07-26.03 42.07 26.03z"}}),_c('path',{attrs:{"fill":"#FFBE1B","d":"M88.038 111.278h25.98v23.95h-25.98z"}})])
          )
        }
      }
    